import { useGenericMutation } from '../useGenericMutation'
import { LocationApi } from '../../api'
import { QUERY_KEYS } from '../../constants'

const useEditLocation = (onSuccess?: () => void) => {
  const {
    mutate: editLocation,
    isSuccess: isEditLocationSuccess,
    isLoading: isEditLocationLoading,
  } = useGenericMutation({
    queryKey: QUERY_KEYS.LOCATIONS,
    mutationFn: LocationApi.updateLocation,
    errorMessage: 'No fue posible modificar la locación',
    successMessage: 'Locación modificada exitosamente',
    onSuccess,
  })

  return {
    editLocation,
    isEditLocationSuccess,
    isEditLocationLoading,
  }
}

export { useEditLocation }
